import Swiper, { Pagination } from 'swiper';
import 'swiper/css';
import 'swiper/css/pagination';
import MicroModal from 'micromodal';

let swiperInstance = null;

const microModalConfig = {
    onShow: (modal) => {
        if (!modal || !modal.classList.contains('modal-livestream-previous')) return;

        window.dataLayer.push({
            event: 'on_page_link_click',
            elementPlacement: 'livestream-carousel',
            elementClicked: 'livestream-modal',
            pageUrl: window.location.href,
            position: 'single',
            linkText: 'Modal Video',
            direction: 'open',
        });
    },
    onClose: (modal) => {
        if (!modal || !modal.classList.contains('modal-livestream-previous')) return;
        const modalIframe = modal.querySelector('.modal-livestream-previous-iframe');
        if (modalIframe) {
            modalIframe.setAttribute('src', '');
        }

        window.dataLayer.push({
            event: 'on_page_link_click',
            elementPlacement: 'livestream-carousel',
            elementClicked: 'livestream-modal',
            pageUrl: window.location.href,
            position: 'single',
            linkText: 'Modal Video',
            direction: 'close',
        });
    },
};

const initSlider = (element) => {
    swiperInstance = new Swiper(element, {
        modules: [Pagination],
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
        loop: false,
        pagination: {
            el: '.livestream-previous-pagination',
            clickable: true,
            renderBullet: (_, className) =>
                `<span class="${className} livestream-previous-pagination-dot"></span>`,
        },
        breakpoints: {
            992: {
                enabled: true,
                slidesPerView: 3,
                slidesPerGroup: 3,
            },
            0: {
                enabled: false,
            },
        },
    });
};

const initOrDestroySlider = () => {
    const carousel = document.querySelector('.livestream-previous-carousel');

    if (!carousel) return;

    if (!swiperInstance) {
        initSlider(carousel);
    }
};

const initSliderPaginationEvents = () => {
    document.querySelector('.livestream-previous-pagination')?.addEventListener('click', function (e) {
        const target = e.target;
        if (!target.classList.contains('swiper-pagination-bullet')) return;

        const index = Array.from(target.parentElement.children).indexOf(target);

        const eventData = {
            event: 'internal_link_click',
            elementPlacement: 'livestream-carousel',
            elementClicked: 'pagination',
            position: index,
            href: '',
            linkText: '',
        };

        window.dataLayer.push(eventData);
        console.log(eventData);
    });
}

const loadLivestreamIframes = (iframe, chatIframe) => {
    if (iframe) {
        iframe.setAttribute('src', iframe.getAttribute('data-iframe-url'));
    }
    if (chatIframe) {
        chatIframe.setAttribute('src', chatIframe.getAttribute('data-iframe-url'));
    }
};

const formatCountdown = (diffMs) => {
    const minutes = Math.floor(diffMs / (1000 * 60)) % 60;
    const hours = Math.floor(diffMs / (1000 * 60 * 60)) % 24;
    const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    const parts = [];
    if (days > 0) parts.push(`${days} day${days !== 1 ? 's' : ''}`);
    if (hours > 0) parts.push(`${hours} hour${hours !== 1 ? 's' : ''}`);
    if (minutes > 0) parts.push(`${minutes} minute${minutes !== 1 ? 's' : ''}`);

    if (parts.length === 0) return 'Less than a minute';
    if (parts.length === 1) return parts[0];

    const last = parts.pop();
    return `${parts.join(', ')} and ${last}`;
};

const handlePreviousStreamsModal = () => {
    const cards = document.querySelectorAll('.livestream-previous-carousel-card');

    if (!cards.length) return;

    const modalIframe = document.querySelector('.modal-livestream-previous-iframe');
    if (!modalIframe) return;

    cards.forEach((card) => {
        const playButton = card.querySelector('.livestream-previous-carousel-card-video-overlay-play');
        const videoId = card.getAttribute('data-id');

        if (!playButton || !videoId) return;

        playButton.addEventListener('click', () => {
            const embedUrl = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
            modalIframe.setAttribute('src', embedUrl);
            MicroModal.show('modal-livestream-previous', microModalConfig);
        });
    });
};

const handleQAFormSubmission = () => {
    const container = document.querySelector('.livestream-live-container-qa-scheduled-form');
    if (!container) return;

    const questionInput = container.querySelector('.livestream-live-container-qa-scheduled-form-question');
    const emailInput = container.querySelector('.livestream-live-container-qa-scheduled-form-email');
    const submitBtn = container.querySelector('.livestream-live-container-qa-scheduled-form-button');
    const optInCheckbox = container.querySelector('input[name="livestream-live-container-qa-scheduled-form-optin"]');
    const submitBtnLabel = submitBtn?.querySelector('.livestream-live-container-qa-scheduled-form-button-label');
    const section = document.querySelector('.livestream[data-timestamp]');
    const liveStart = section?.getAttribute('data-timestamp');
    const videoId = section?.getAttribute('data-video-id');

    if (!submitBtn || !emailInput || !questionInput || !liveStart) return;

    const submittedLabel = 'Submitted';

    const disableForm = (showLabel = false) => {
        emailInput.value = '';
        questionInput.value = '';

        emailInput.setAttribute('disabled', 'disabled');
        questionInput.setAttribute('disabled', 'disabled');
        submitBtn.classList.remove('loading');
        submitBtn.classList.add('disabled');
        submitBtn.dataset.submitted = '1';

        const successMessage = container.querySelector('.livestream-live-container-qa-scheduled-form-success-message');
        if (successMessage) {
            successMessage.classList.remove('hidden');
        }

        if (showLabel && submitBtnLabel) {
            submitBtnLabel.textContent = submittedLabel;
        }
    };

    const fireLeadFormSubmissionEvent = (status, reason = '') => {
        window.dataLayer.push({
            event: 'lead_form_submission',
            leadFormId: '#livestreamQAForm',
            submissionStatus: status,
            ...(status === 'error' ? { errorReason: reason } : {}),
        });
        console.log(`[lead_form_submission] ${status}${reason ? ` – ${reason}` : ''}`);
    };

    questionInput.addEventListener('input', () => {
        questionInput.setCustomValidity('');
    });

    emailInput.addEventListener('input', () => {
        emailInput.setCustomValidity('');
    });

    submitBtn.addEventListener('click', () => {
        if (submitBtn.classList.contains('loading') || submitBtn.classList.contains('disabled')) return;

        const trimmedQuestion = questionInput.value.trim();

        if (!trimmedQuestion) {
            questionInput.setCustomValidity('Please enter a valid question.');
            questionInput.reportValidity();
            fireLeadFormSubmissionEvent('error', 'empty or whitespace question');
            return;
        } else {
            questionInput.setCustomValidity('');
        }

        const trimmedEmail = emailInput.value.trim();
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

        if (!emailRegex.test(trimmedEmail)) {
            emailInput.setCustomValidity('Please enter a valid email address.');
            emailInput.reportValidity();
            fireLeadFormSubmissionEvent('error', 'invalid email format');
            return;
        } else {
            emailInput.setCustomValidity('');
        }

        const email = trimmedEmail;
        const question = trimmedQuestion;

        submitBtn.classList.add('loading');

        fetch(window.site_settings.admin_ajax, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: new URLSearchParams({
                action: 'livestream_qa',
                email,
                question,
                opt_in: optInCheckbox.checked ? '1' : '0',
                live_starts: liveStart,
                video_id: videoId || '',
            }),
        })
            .then((res) => res.json())
            .then((json) => {
                if (!json.success) {
                    fireLeadFormSubmissionEvent('error', json?.data?.message || 'server error');
                    throw new Error(json?.data?.message || 'Submission failed.');
                }
                fireLeadFormSubmissionEvent('success');
            })
            .catch(() => {
                submitBtn.classList.remove('loading');
            })
            .finally(() => {
                disableForm(true);
            });
    });
};

export default function init() {
    document.addEventListener('DOMContentLoaded', () => {
        const section = document.querySelector('.livestream[data-timestamp]');
        if (!section) return;

        const countdownEl = section.querySelector('.livestream-countdown.scheduled b');
        const iframe = section.querySelector('.livestream-live-container-video-frame iframe');
        const chatIframe = section.querySelector('.livestream-live-container-qa-live iframe');
        const targetTimestamp = parseInt(section.getAttribute('data-timestamp'), 10) * 1000;

        let framesLoaded = false;
        let countdownInterval;

        const maybeLoadFrames = () => {
            if (framesLoaded) return;
            loadLivestreamIframes(iframe, chatIframe);
            framesLoaded = true;
        };

        const updateCountdown = () => {
            if (!countdownEl) return;
            const now = Date.now();
            const diff = targetTimestamp - now;

            if (diff <= 0) {
                countdownEl.textContent = 'Now Live';
                clearInterval(countdownInterval);
                section.classList.add('live');

                if (document.readyState === 'complete') {
                    maybeLoadFrames();
                } else {
                    window.addEventListener('load', maybeLoadFrames);
                }

                return;
            }

            countdownEl.textContent = formatCountdown(diff);
        };

        updateCountdown();
        countdownInterval = setInterval(updateCountdown, 60 * 1000);

        initOrDestroySlider();
        initSliderPaginationEvents();

        handlePreviousStreamsModal();
        handleQAFormSubmission();

        section.classList.add('visible');
    });
}